<!--
/**
 * @copyright   OnlyOneProd © 2025
 * @authors     Jonathan COULLET <contact@onlyoneprod.com>
 * @link        https://onlyoneprod.com
 * @notice      All information contained herein is,
 *              and remains the property of OnlyOneProd and its suppliers,
 *              Any dissemination of this information or reproduction
 *              of this material is strictly forbidden unless prior
 *              written permission is obtained from OnlyOneProd.
 */
-->

<template>
    <svg width="48" height="48" viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg">
        <g>
            <path
                d="M15.3 43.4C14.541 43.4 13.9012 43.1398 13.3805 42.6195C12.8602 42.0992 12.6 41.4593 12.6 40.7V7.3C12.6 6.54067 12.8602 5.90083 13.3805 5.3805C13.9012 4.86017 14.541 4.6 15.3 4.6H32.7C33.4593 4.6 34.0992 4.86017 34.6195 5.3805C35.1398 5.90083 35.4 6.54067 35.4 7.3V40.7C35.4 41.4593 35.1398 42.0992 34.6195 42.6195C34.0992 43.1398 33.4593 43.4 32.7 43.4H15.3ZM13.7 35.55V40.7C13.7 41.1 13.8667 41.4667 14.2 41.8C14.5333 42.1333 14.9 42.3 15.3 42.3H32.7C33.1 42.3 33.4667 42.1333 33.8 41.8C34.1333 41.4667 34.3 41.1 34.3 40.7V35.55H13.7ZM24.0095 40.15C24.3365 40.15 24.625 40.0303 24.875 39.791C25.125 39.552 25.25 39.2603 25.25 38.916C25.25 38.572 25.1218 38.275 24.8655 38.025C24.6088 37.775 24.3172 37.65 23.9905 37.65C23.6635 37.65 23.375 37.7782 23.125 38.0345C22.875 38.2908 22.75 38.5823 22.75 38.909C22.75 39.2697 22.8782 39.5667 23.1345 39.8C23.3912 40.0333 23.6828 40.15 24.0095 40.15ZM13.7 34.45H34.3V9.95H13.7V34.45ZM13.7 8.85H34.3V7.3C34.3 6.9 34.1333 6.53333 33.8 6.2C33.4667 5.86667 33.1 5.7 32.7 5.7H15.3C14.9 5.7 14.5333 5.86667 14.2 6.2C13.8667 6.53333 13.7 6.9 13.7 7.3V8.85Z"
                fill="currentColor" />
        </g>
    </svg>
</template>

<style lang="sass">
</style>